var React = require('react');

var GenericForm = require('../Form/GenericForm');
var Input = require('../Form/Input');
var PasswordRow = require('../Form/PasswordRow');

var ClientServiceEmailForm = React.createClass({
    propTypes: {
        cancelButtonClasses: React.PropTypes.object,
        cancelHandler: React.PropTypes.func,
        createHandler: React.PropTypes.func,
        disableButtons: React.PropTypes.bool,
        emailAddress: React.PropTypes.string,
        emailSuffix: React.PropTypes.string,
        errors: React.PropTypes.array,
        showCancel: React.PropTypes.bool,
        showPassword: React.PropTypes.bool,
        submitButtonClasses: React.PropTypes.object
    },
    getData: function () {
        return {
            email: this.refs.email.getValue() + (this.props.emailSuffix ? '@' + this.props.emailSuffix : ''),
            password: this.refs.password ? this.refs.password.getPassword() : null
        }
    },
    getDefaultProps: function () {
        return {
            cancelButtonText: 'Cancel',
            disableButtons: false,
            emailSuffix: '',
            errors: [],
            showCancel: true,
            showPassword: true,
            submitButtonText: <span><i className="fa fa-plus"></i> Create</span>
        }
    },
    render: function () {
        var commonAttr = {
            labelClassName: "col-md-3",
            wrapperClassName: "col-md-9"
        };

        var inputAttr = {
            disabled: !!this.props.emailAddress,
            label: 'Email Address',
            addonAfter: this.props.emailSuffix && "@" + this.props.emailSuffix,
            value: this.props.emailAddress
        };

        if (this.props.errors) {
            var errors = this.props.errors.map(function (error) { return error.message; });
            if (errors.length) {
                inputAttr.help = errors.join(' ');
                inputAttr.bsStyle = 'error';
                inputAttr.hasFeedback = true;
            }
        }

        return <GenericForm
            cancelButtonClasses={this.props.cancelButtonClasses}
            cancelButtonText={this.props.cancelButtonText}
            cancelHandler={this.props.cancelHandler}
            disableButtons={this.props.disableButtons}
            horizontal={3}
            showCancel={this.props.showCancel}
            submitButtonClasses={this.props.submitButtonClasses}
            submitButtonText={this.props.submitButtonText}
            submitHandler={this._submit}
        >
            <Input ref="email" type="text" {...inputAttr} {...commonAttr} />
            {this.props.showPassword && <PasswordRow ref="password" label="Password" horizontal={3} />}
        </GenericForm>;
    },
    _submit: function (e) {
        this.props.submitHandler(e, this.getData());
    }
})
module.exports = ClientServiceEmailForm;



// WEBPACK FOOTER //
// ./app/components/ClientServiceEmail/Form.js